import { Box, Card, Typography, useTheme } from '@mui/material';
import React from 'react';
import AppImage from '../../AppImage';
import TextWithCharacterLimit from '../../TextWithCharacterLimit';
export default function CatalogItem({ data, onClick }) {
  const theme = useTheme();
  const hasImage = Boolean(data?.images);
  const imageSize = hasImage ? '40px' : '30px';

  return (
    <Card
      variant="outlined"
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '8px',
        backgroundColor: theme.palette.background.light,
        width: '100%',
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <AppImage
          alt="product"
          max-width={imageSize}
          max-height={imageSize}
          src={data.images}
          placeholderPath="/static/img/product.svg"
          style={{ borderRadius: '5px' }}
        ></AppImage>
      </Box>
      <Box style={{ flexGrow: 1, marginLeft: '6px' }}>
        <Box display="flex" alignItems="center">
          <Typography variant="subtitle2">#{data?.product_sku}</Typography>
          {data?.product_name && (
            <Box display="flex" style={{ marginLeft: '6px' }} alignItems="center">
              <TextWithCharacterLimit value={data?.product_name} limit={30} variant="body2" color="textSecondary" />
            </Box>
          )}
        </Box>
        <Box display="flex" alignItems="center">
          {data?.stock !== null && data?.stock !== undefined ? (
            <>
              <Typography variant="body1" style={{ fontSize: '12px' }}>
                Sellable Stock - {data?.stock}
              </Typography>
              <Box height={'4px'} width={'4px'} border={'2px solid'} borderRadius={'50%'} mx={2} />
            </>
          ) : null}

          <Typography variant="body1" style={{ fontSize: '12px' }}>
            {data?.marketplace_name}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
}
